// src/components/course/ReviewRatingStars.js
import React from "react";

function ReviewRatingStars({ value = 0, max = 5, onChange, readOnly = false }) {
  // readOnly(리스트/헤더)일 때는 작게, 입력 모드일 때는 크게 스타일 분기
  const starSize = readOnly ? "text-sm" : "text-3xl";
  const gapSize = readOnly ? "gap-0.5" : "gap-2";

  return (
    <div className={`flex items-center ${gapSize}`}>
      {Array.from({ length: max }).map((_, idx) => {
        const starValue = idx + 1;
        const filled = starValue <= value;

        const handleClick = () => {
          if (readOnly) return;
          onChange && onChange(starValue);
        };

        return (
          <button
            key={starValue}
            type="button"
            disabled={readOnly}
            onClick={handleClick}
            className={`transition-transform ${
              readOnly
                ? "cursor-default" // 읽기 전용일 땐 커서 기본
                : "cursor-pointer hover:scale-110 active:scale-95" // 입력 모드일 땐 인터랙션 효과
            }`}
          >
            <span
              className={`${starSize} ${
                filled ? "text-yellow-400" : "text-gray-200"
              }`}
            >
              ★
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default ReviewRatingStars;
